/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ApplyInputs */



/**
* | output |
* | --- |
* | "Apply" |
*
* @param {ApplyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const apply = /** @type {((inputs?: ApplyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ApplyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appliquer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anwenden")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fare domanda a")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Применять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aplicar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("申请")
	if (locale === "ja") return /** @type {LocalizedString} */ ("適用する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आवेदन करना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Aplicar")
	return /** @type {LocalizedString} */ ("Apply")
});